import { useQuery } from '@apollo/client';

import toHumanReadableTypeName from 'bundles/learner-progress/utils/toHumanReadableTypeName';
import GetItemInfoQuery from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/GetItemInfo.graphql';
import type {
  LearnerMaterialItemsFragment,
  GetItemInfoQuery as QueryResult,
  GetItemInfoQueryVariables as QueryVariables,
} from 'bundles/skills-common/shared/verified-skills/data/skill-pathway/__generated__/GetItemInfo';

type Props = {
  courseId: string;
  itemIds: string[];
  skip?: boolean;
};

export type ItemDetail = {
  itemId: string;
  name: string;
  slug: string;
  totalWorkDuration: number;
  contentSummary: {
    __typename: string;
  };
};

const useGetItemDetails = ({ courseId, itemIds, skip }: Props) => {
  const { data, loading } = useQuery<QueryResult, QueryVariables>(GetItemInfoQuery, {
    variables: {
      itemIds,
      courseId,
    },
    skip: skip || !courseId || !itemIds.length,
    context: { clientName: 'gatewayGql' },
  });

  // Extract items from the response and map to our expected format
  const items: ItemDetail[] =
    data?.NaptimeQueries?.OnDemandLearnerMaterialItemsV1Resource?.items?.elements
      ?.filter((item): item is LearnerMaterialItemsFragment => item !== null && item !== undefined)
      ?.map((item) => ({
        itemId: item.itemId,
        name: item.name,
        slug: item.slug,
        contentSummary: item.contentSummary,
        totalWorkDuration: item.totalWorkDuration,
      })) || [];

  return {
    items,
    loading,
  };
};

export const getItemTypeLabel = (typename: string): string => {
  return toHumanReadableTypeName(typename.replace('OnDemandLearnerMaterialItemsV1_', '').replace('Member', '')) || '';
};

export default useGetItemDetails;
